export default __webpack_public_path__ + "static/beacon-landing-hero-546dbf20c01636401c6a96c47f985e22.webm";